import React from 'react';
import { motion } from 'framer-motion';
import { HeartHandshake } from 'lucide-react';
export function EmotionalGuarantee() {
  return <section className="py-16 px-4 bg-[#0C0F17]" data-id="element-96">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-50px'
    }} transition={{
      duration: 0.6,
      ease: [0.22, 1, 0.36, 1]
    }} className="max-w-3xl mx-auto bg-[#111522] border border-[#CFA86A]/30 rounded-2xl p-8 md:p-12 text-center" data-id="element-97">
        <HeartHandshake className="w-12 h-12 text-[#CFA86A] mx-auto mb-6 opacity-80" data-id="element-98" />
        <h3 className="font-serif text-2xl font-bold text-[#F7F5F2] mb-4" data-id="element-99">
          Confianza en tu intuición
        </h3>
        <p className="text-[#F7F5F2]/80 text-lg leading-relaxed" data-id="element-100">
          Si esta lectura no resuena contigo, no continúes. Tu intuición siempre
          tiene la última palabra. Este es un espacio seguro para tu exploración
          emocional.
        </p>
      </motion.div>
    </section>;
}